const Config = {
     apiUrl: 'https://asp-cbe-webapp-production-2fkrmdpsk7vdk.azurewebsites.net/api',
                      
    //apiUrl: 'https://cbe-reporting.azurewebsites.net/api',
  };
  
  export default Config;